import React, { FunctionComponent } from 'react';
import { ForgeButton } from '@tylertech/forge-react';
import { useDispatch } from 'react-redux';

import { I18n } from 'common/i18n';
import { selectAssetForComponent, providerChosen } from 'store/reducers/AssetSelectorReducer';

export const SelectDatasetButton: FunctionComponent<{
  blockId: string;
  componentIndex: number;
}> = ({ blockId, componentIndex }) => {
  const dispatch = useDispatch();

  const launchDatasetSelector = () => {
    dispatch(
      selectAssetForComponent({
        blockId,
        componentIndex,
      }),
    );

    dispatch(
      providerChosen({
        blockId,
        componentIndex,
        provider: 'GLOBAL_FILTER',
      }),
    );
  };

  return (
    <ForgeButton variant="outlined" onClick={launchDatasetSelector}>
      <span>{I18n.t('editor.data_and_filtering_panel.add_data_source')}</span>
    </ForgeButton>
  );
};
